/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetMoneybotHomeRequest} from '@cash-web/protos/squareup/cash/cashfrontdoor/api/v1beta1/moneybot_home_proto.pb'
import {GetMoneybotHomeResponse} from '@cash-web/protos/squareup/cash/cashfrontdoor/api/v1beta1/moneybot_home_proto.pb'


export const getMoneybotHome = (request: GetMoneybotHomeRequest, options?: CashRequestOptions) => post<GetMoneybotHomeRequest, GetMoneybotHomeResponse>("/cash-app/frontdoor/get-moneybot-home", request, {...options, rejectOnError: true })